<template>
    <a
        :class="{
            'l-ss-c-completions-item-is-active': isActive,
            'l-ss-c-completions-item-is-current': (data.active === 1),
            [`l-ss-c-completions-item-type-${labelToken}`]: Boolean(labelToken)
        }"
        :href="data.url"
        :target="$configuration.linkTargetBlank ? '_blank': '_self'"
        class="l-ss-c-completions-item">
        <div
            class="l-ss-c-completions-item-content">
            <div
                v-if="showImage"
                class="l-ss-c-completions-item-thumbnail-wrapper">
                <span class="l-ss-c-completions-item-thumbnail">
                    <i
                        :class="{ 'l-ss-c-completions-item-thumbnail-stub-is-active': !isActiveImageLoaded || isActiveImageError }"
                        class="l-ss-c-completions-item-thumbnail-stub"
                        :style="`background-image: url(${errorCustomImg});`"
                        v-if="errorCustomImg"></i>
                    <i
                        :class="{ 'l-ss-c-completions-item-thumbnail-stub-is-active': !isActiveImageLoaded || isActiveImageError }"
                        class="l-ss-c-completions-item-thumbnail-stub"
                        v-if="!errorCustomImg"
                        v-html="noPhotoIcon"></i>
                    <img
                        v-show="isActiveImageLoaded && !isActiveImageError"
                        :src="imageUrlValue"
                        alt="product"
                        class="l-ss-c-completions-item-thumbnail-image"
                        @error="handleImageError"
                        @load="handleImageLoad">
                </span>
            </div>
            <div class="l-ss-c-completions-item-main-data">
                <div class="l-ss-c-completions-item-title-wrapper">
                    <span
                        v-if="isCatPrefixActive && textPrefix"
                        class="l-ss-c-completions-item-prefix">
                        <span
                            class="l-ss-c-completions-item-prefix-value"
                            v-html="textPrefix">
                        </span>
                    </span>
                    <span
                        class="l-ss-c-completions-item-title"
                        v-html="textLabel || textValue"></span>
                    <i
                        v-if="data.label === 'history'"
                        class="l-ss-c-search-input-icon l-ss-c-search-hints-icon-remove"
                        v-html="iconDeleteQuery"
                        @click.stop="removeUserHint(data)"></i>
                    <span
                        v-if="data.count && data.label !== 'offers'"
                        class="l-ss-c-completions-item-count l-ss-c-count-tag">{{ data.count }}</span>
                </div>
                <div
                    class="l-ss-c-completions-item-caption-wrapper"
                    :class="{ column: $configuration.completionsFullWidth }">
                    <span
                        v-if="data.offer_code"
                        :title="data.offer_code"
                        class="l-ss-c-completions-item-caption l-ss-c-completions-item-caption-vendor-code"
                        :class="{ 'half-width': data.snippet }">
                        {{ $t('vendorCode') }} {{ data.offer_code }}
                    </span>
                    <span
                        class="l-ss-c-completions-item-snippet"
                        @mouseover="showSnippetTooltip($event)"
                        @mouseleave="closeSnippetTooltip($event)">
                        <span
                            v-if="data.snippet"
                            ref="completionsItemCaption"
                            class="l-ss-c-completions-item-caption">
                            {{ data.snippet }}
                        </span>
                        <span
                            v-if="isShowSnippetTooltip"
                            ref="snippetTooltip"
                            class="l-ss-c-completions-item-snippet-tooltip"
                            :class="{ 'active': isActiveSnippetTooltip }">
                            {{ data.snippet }}
                        </span>
                    </span>
                </div>
                <div
                    v-if="data.offer.count && $configuration.showOfferCount && data.label === 'offers' && false"
                    class="l-ss-c-completions-item-instock">
                    {{ $t('inStock', { pieces: data.offer.count }) }}
                </div>
                <div
                    v-if="hasOfferLabels"
                    :class="{ 'l-ss-c-offer-label-wrapper-full-width': $configuration.completionsFullWidth }"
                    class="l-ss-c-offer-labels-wrapper">
                    <div
                        v-for="label in offerLabels"
                        :key="label.id"
                        class="l-ss-c-offer-label-wrapper">
                        <span
                            :class="[`l-ss-c-offer-label-type-${label.id}` , { 'l-ss-c-offer-label-type-available': label.id === 'available' || data.offer.available }]"
                            class="l-ss-c-offer-label l-ss-c-offer-label-text">
                            {{ label.labelTitle }}
                        </span>
                    </div>
                </div>
                <span
                    v-if="annotation"
                    class="l-ss-c-completions-item-annotation">{{ annotation }}</span>
                <price
                    v-if="showPrices"
                    :offer="data"
                    class="l-ss-c-completions-item-prices-wrapper"/>
            </div>
        </div>
        <div
            class="l-ss-c-completions-item-actions">
            <cart
                v-if="showCartButton"
                :show-cart-button="showCartButton"
                :count="count"
                :offer="getOffer"
                @add-to-cart="(payload) => $emit('add-to-cart', payload)"/>
            <span
                v-show="provision(labelToken)"
                class="l-ss-c-completions-item-label">
                {{ customLabel ? customLabel : $t(`completions.category.${labelToken}`) }}
            </span>
        </div>

    </a>
</template>

<script>
    import noPhotoIcon from '../../assets/images/no-photo.svg';
    import { currencyAsString } from '../../helpers/display';
    import delegateEvent from '../../helpers/delegate-event';
    import cutText from '../../helpers/cut-text';
    import iconDeleteQuery from '../../../core/assets/images/icons/delete.svg';
    import Price from '@/core/components/price';
    import Cart from '@/core/components/cart';

    export default {
        components: {
            Cart,
            Price,
        },
        props: {
            isActive: {
                type: Boolean,
                required: false,
                default: false,
            },
            isCartAvailable: {
                type: Boolean,
                default: false,
            },
            isCatPrefixActive: {
                type: Boolean,
                default: true,
            },
            data: { // Backend response completions item
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                isActiveImageError: false,
                isActiveImageLoaded: false,
                errorCustomImg: false,
                isShowSnippetTooltip: false,
                isActiveSnippetTooltip: false,
            };
        },
        computed: {
            count() {
                return this.$configuration.cartCount?.completions?.count;
            },
            oldPrice() {
                return (this.data.old_price !== this.data.price) ? this.data.old_price : null;
            },
            showCartButton() {
                return (
                    this.isCartAvailable &&
                    this.data?.offer?.available
                );
            },
            iconDeleteQuery() {
                return iconDeleteQuery;
            },
            showPrices() {
                return this.data.price || this.data.old_price || !!this.data.prices;
            },
            textPrefix() {
                if (!this.data.hierarchy) {
                    return '';
                }
                const textLength = this.textValue.length;
                const maxLengthMobile = 30;
                const maxLengthDesktop = 65;
                const minPrefixLength = 10;
                const prefixLength = this.data.hierarchy.length;
                let resLength = 0;

                if (this.$screen.isMobile) {
                    resLength = maxLengthMobile - textLength;
                } else {
                    resLength = maxLengthDesktop - textLength;
                }

                if ((resLength >= minPrefixLength) || (prefixLength <= minPrefixLength)) {
                    return this.data.hierarchy ? cutText(this.data.hierarchy ?? '', resLength) : '';
                }
                return '';
            },
            textLabel() {
                return this.data.text.html || this.data.text.label || '';
            },
            textValue() {
                return this.data.text.value || this.data.text.label || '';
            },
            customLabel() {
                return this.data.displayed_label || '';
            },
            urlValue() {
                return this.data.url;
            },
            imageUrlValue() {
                return this.data.image_url;
            },
            labelToken() {
                return this.data.label;
            },
            annotation() {
                return this.data.annotation;
            },
            hasUrl() {
                return !!this.data.url;
            },
            showImage() {
                return this.data.image_url || this.labelToken === 'offers';
            },
            noPhotoIcon() {
                return this.errorCustomImg || noPhotoIcon;
            },
            getOffer() {
                return {
                    id: this.data.id,
                    name: this.textLabel,
                    price: this.data.price || this.data.old_price,
                    quantity: this.quantity,
                    img: this.data.image_url,
                    url: this.data.url,
                    data: this.data,
                };
            },
            offerLabels() {
                const labels = this.data.offer.labels ?? [];
                return labels.map(label => ({
                    labelTitle: this.$t(`labels.${label.id}`, null, label.title),
                    ...label,
                }));
            },
            hasOfferLabels() {
                return this.offerLabels.length > 0;
            },
        },
        created() {
            if (this.$configuration.errorImg) {
                const errorImg = document.createElement('img');
                errorImg.src = this.$configuration.errorImg;
                errorImg.onload = () => {
                    this.errorCustomImg = this.$configuration.errorImg;
                };
                errorImg.onerror = () => {
                    this.errorCustomImg = false;
                };
            }
        },
        methods: {
            removeUserHint(data) {
                this.$emit('remove-history', data);
            },
            provision(labelToken) {
                return (labelToken && !this.$screen.isMobile && !['offers', 'extra_offer'].includes(labelToken));
            },
            getPriceLabel(value) {
                return value ? currencyAsString(value, this.data.currency) : '';
            },
            handleImageError(event) {
                if (this.errorCustomImg) {
                    event.target.src = this.errorCustomImg;
                } else {
                    this.isActiveImageError = true;
                }
            },
            handleImageLoad() {
                this.isActiveImageLoaded = true;
            },
            handleClick(event) {
                delegateEvent(event, {
                    addToCart: () => this.addToCart(this.getOffer),
                });
            },
            async showSnippetTooltip(event) {
                if (this.$refs.completionsItemCaption) {
                    if (this.$refs.completionsItemCaption.clientWidth < this.$refs.completionsItemCaption.scrollWidth) {
                        this.isShowSnippetTooltip = true;
                        await this.$nextTick();
                    }
                }
                if (!this.isShowSnippetTooltip) {
                    return;
                }
                if (!this.isActiveSnippetTooltip) {
                    const searchPopup = document.querySelector('searchbooster-search-popup');
                    const searchPopupRoot = searchPopup.shadowRoot.querySelector('.l-ss-c-search-popup.l-ss-c-root');
                    const searchPopupRect = searchPopupRoot.getBoundingClientRect();
                    const extraTopOffset = 16;
                    const snippetTooltipTopOffset = event.target.getBoundingClientRect().top - searchPopupRect.top + extraTopOffset;
                    const snippetTooltipLeftOffset = event.target.getBoundingClientRect().left - searchPopupRect.left;

                    this.$refs.snippetTooltip.style = `top: ${snippetTooltipTopOffset}px; left: ${snippetTooltipLeftOffset}px;`;
                }

                this.isActiveSnippetTooltip = true;
            },
            closeSnippetTooltip(event) {
                this.isActiveSnippetTooltip = false;
            },
        },
    };
</script>
